import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from '../components/EmployerDashboard/Navbar';
import PostJob from '../components/EmployerDashboard/PostJob';
import Dashboard from '../components/EmployerDashboard/Dashboard';
import InternshipPage from '../components/EmployerDashboard/InternshipPage';
import EmployerJobDescription from '../components/EmployerDashboard/EmployerJobDescription';
import Candidates from '../components/EmployerDashboard/Candidates';
// import ResumeDatabase from '../components/EmployerDashboard/ResumeDatabase';
// import Messages from '../components/EmployerDashboard/Messages';
import EmployerProfilePage from '../components/EmployerDashboard/EmployerProfilePage';

function Employers() {
  const [isNavbarOpen, setIsNavbarOpen] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarOpen(!isNavbarOpen);
  };

  return (
    <div className={`employer-section ${isNavbarOpen ? 'navbar-open' : 'navbar-closed'}`}>
      <Navbar isOpen={isNavbarOpen} toggleNavbar={toggleNavbar} setIsOpen={setIsNavbarOpen} />
      <div className="content">
        <Routes>
          <Route path="post-job" element={<PostJob />} />
          <Route path="edit-job/:id" element={<PostJob />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="internship" element={<InternshipPage />} />
          <Route path="/internship/:id/description" element={<EmployerJobDescription />} />
          <Route path="candidates" element={<Candidates />} />
          {/* <Route path="resume-database" element={<ResumeDatabase />} /> */}
          {/* <Route path="messages" element={<Messages />} /> */}
          <Route path="profile-settings" element={<EmployerProfilePage />} />
          <Route path="/" element={<Dashboard />} />
        </Routes>
      </div>
    </div>
  );
}

export default Employers;